import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, View, TouchableOpacity } from 'react-native';
import * as RootNavigation from '../../../root.navigation.js';

const width = Dimensions.get('window').width;


const PlusIcon = (props) => (
  <Icon {...props} name='plus-square-outline' />
);
const ClockIcon = (props) => (
  <Icon {...props} name='clock-outline' fill='#134A93' style={[props.style, {width:24,height:24, marginHorizontal:8 }]}/>
);
const CalendarIcon = (props) => (
  <Icon {...props} name='calendar-outline' fill='#134A93' style={[props.style, {width:24,height:24, marginHorizontal:8 }]}/>
);
export const SingleNewsScreen = ({route}) => {

  console.log('params', route.params.news);
  return (
      <Layout style={styles.container} level='3' >
      <SafeAreaView>
        <View style={{flex:1,justifyContent:'space-between'}}>
        <View>
        <Text category='h5' status='primary' style={{marginTop:20, textAlign:'center'}}>{route.params.news.title}</Text>
          <View style={{flexDirection:'row', justifyContent:'space-around', width: width-30, marginTop:20}} >
            <View style={{flexDirection:'row', alignItems:'center'}}>
            <ClockIcon /><Text category='h6' status='primary'>{route.params.news.create_date.split('T')[1].split('.')[0]}</Text>
            </View>
            <View style={{flexDirection:'row', alignItems:'center'}}>
            <CalendarIcon /><Text category='h6' status='primary'>{route.params.news.create_date.split('T')[0]}</Text>
            </View>
          </View>

          <View style={{borderRadius:10, marginTop:20, alignItems:'flex-start', width:width-50, marginHorizontal:25}}>

          <Text status='primary' style={{marginTop:25}}>نوع پیام: {route.params.news.receiver != 'all' ? 'مختص به شما' : 'عمومی'}</Text>
        </View>
        <View style={{borderRadius:10, marginTop:20, alignItems:'flex-start', width:width-50, marginHorizontal:25}}>

          <Text status='primary'>متن اطلاعیه:</Text>
          <Text style={{marginTop:5}}>{route.params.news.context}</Text>
        </View>
        </View>
        <Button onPress={()=>{RootNavigation.navigate('News')}} appearance='outline' style={{borderRadius:10, margin:20}}>بازگشت</Button>
        </View>
      </SafeAreaView>
      </Layout>

  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems:'center',
    justifyContent:'flex-start',

  },
});
